import { StockKanbanComplectState, type StockKanbanComplectStateValue } from "../../../api/stockKanbanContainers";

const COMPLECT_STATE_LABELS: Record<StockKanbanComplectStateValue, string> = {
    [StockKanbanComplectState.Idle]: "Не взят на комплект.",
    [StockKanbanComplectState.InProgress]: "Взят на комплект",
    [StockKanbanComplectState.Finished]: "Скомплектован",
};

/**
 * Человекочитаемый статус комплектования контейнера КАНБАН.
 * @param state wire-значение `ComplectState` (`0` / `1` / `2`)
 */
export function formatComplectState(state: StockKanbanComplectStateValue): string {
    return COMPLECT_STATE_LABELS[state] ?? `Статус ${state}`;
}
